import { ResponseBase } from '../Messaging/ResponseBase';

/**
 * Respond to a ToastMessage.
 */
export class ToastResponse extends ResponseBase {
  // NOP
}
